import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { SidebarModule } from 'primeng/sidebar';
import { TimedurationPipe } from './timeduration.pipe';
import { RightcolumnComponent } from './rightcolumn/rightcolumn.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    AutoCompleteModule,
    CalendarModule,
    RadioButtonModule,
    OverlayPanelModule,
    InputSwitchModule,
    CheckboxModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    CardModule,
    SidebarModule
  ],
  declarations: [
    RightcolumnComponent
  ],
  exports: [ RightcolumnComponent ]
})
export class SharedModel {}
